"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __values = (this && this.__values) || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var TokenRenderers_1 = require("./TokenRenderers");
var CommonWidgetRegistry_1 = require("@CommonFrontend/WidgetRegistry/CommonWidgetRegistry");
var GetBlockStyle_1 = require("@CommonFrontendBackend/StyleServiceV2/GetBlockStyle");
var dynamic_1 = require("@vanilla-extract/dynamic");
var Resizeable_css_1 = require("./TokenRenderers/Resizeable.css");
var classnames_1 = __importDefault(require("classnames"));
var Alignable_css_1 = require("./TokenRenderers/Alignable.css");
var tokenRenderer = function (tokens, options) {
    var html = "";
    if (!tokens || !tokens.length) {
        return html;
    }
    var currentBlock = null;
    var innerHtml = "";
    var currentIndex = 0;
    for (var i = 0; i < tokens.length; i++) {
        var token = tokens[i];
        if (token.type == "block") {
            if (currentBlock != undefined) {
                html += renderBlock(currentBlock, currentIndex, tokens, innerHtml, options);
                innerHtml = "";
            }
            currentBlock = token;
            currentIndex = i;
        }
        else if (token.type == "inline") {
            innerHtml += renderInlineToken(token);
        }
    }
    html += renderBlock(currentBlock, currentIndex, tokens, innerHtml, options);
    return html;
};
var makeStylableAttributes = function (token, options) {
    var e_1, _a;
    var _b, _c, _d, _e, _f;
    var styleableConfig = (0, CommonWidgetRegistry_1.getTraitConfig)({ widgetType: token.subType, traitName: "styleable" });
    if (styleableConfig) {
        var style = {};
        try {
            for (var _g = __values(styleableConfig.properties), _h = _g.next(); !_h.done; _h = _g.next()) {
                var property = _h.value;
                if (!property.var)
                    continue;
                if (property.type === "color") {
                    var styleColor = (_d = (_c = (_b = options === null || options === void 0 ? void 0 : options.blockStyles) === null || _b === void 0 ? void 0 : _b[styleableConfig.styleKey]) === null || _c === void 0 ? void 0 : _c[property.name]) !== null && _d !== void 0 ? _d : {
                        themeIndex: 0,
                    };
                    style[property.var] = (_f = (0, GetBlockStyle_1.sanitizeColor)(styleColor, (_e = options.brandColors) !== null && _e !== void 0 ? _e : [])) === null || _f === void 0 ? void 0 : _f.value;
                }
                else {
                    throw new Error("Unsupported property type");
                }
            }
        }
        catch (e_1_1) { e_1 = { error: e_1_1 }; }
        finally {
            try {
                if (_h && !_h.done && (_a = _g.return)) _a.call(_g);
            }
            finally { if (e_1) throw e_1.error; }
        }
        return { style: (0, dynamic_1.assignInlineVars)(style) };
    }
};
var makeResizeableAttributes = function (token) {
    var _a;
    if ((0, CommonWidgetRegistry_1.isResizeableWidget)(token)) {
        var resizeableConfig = (0, CommonWidgetRegistry_1.getTraitConfig)({ widgetType: token.subType, traitName: "resizeable" });
        var attributes = { style: {} };
        if (!token.width) {
            return {};
        }
        if (typeof token.width !== "number") {
            attributes.className = (0, Resizeable_css_1.resizeableWidget)({
                width: token.width,
                fullBleedOnMobile: (_a = resizeableConfig.width.fullBleedOnMobile) !== null && _a !== void 0 ? _a : true,
            });
        }
        else {
            attributes.style.width = "".concat(token.width, "%");
            if (!(0, CommonWidgetRegistry_1.isAlignableWidget)(token)) {
                attributes.style.marginLeft = "auto";
                attributes.style.marginRight = "auto";
            }
        }
        if (token.height) {
            attributes.style.aspectRatio = "1 / calc(".concat(token.height, " * 0.01)");
        }
        return attributes;
    }
};
var makeSpacingShimAttributes = function (token) {
    var traitConfig = (0, CommonWidgetRegistry_1.getTraitConfig)({ widgetType: token.subType, traitName: "spacingShim" });
    if (!traitConfig) {
        return undefined;
    }
    return { className: traitConfig.className };
};
var makeAlignableAttributes = function (token) {
    var _a;
    if ((0, CommonWidgetRegistry_1.isResizeableWidget)(token)) {
        if (["wide", "full"].includes(token.width)) {
            return undefined;
        }
    }
    if ((0, CommonWidgetRegistry_1.isAlignableWidget)(token)) {
        var alignableConfig = (0, CommonWidgetRegistry_1.getTraitConfig)({ widgetType: token.subType, traitName: "alignable" });
        return {
            className: (0, Alignable_css_1.alignableWidget)({ alignment: (_a = token.alignment) !== null && _a !== void 0 ? _a : alignableConfig.defaultAlignment }),
        };
    }
};
var renderBlock = function (token, index, tokens, innerHtml, options) {
    var _a, _b, _c;
    if (options === void 0) { options = {}; }
    var registryRenderer = (_a = (0, CommonWidgetRegistry_1.getGenericConfigByType)(token.subType)) === null || _a === void 0 ? void 0 : _a.publicRender;
    if (registryRenderer) {
        var resizeableAttributes = makeResizeableAttributes(token);
        var styleableAttributes = makeStylableAttributes(token, options);
        var spacingShimAttributes = makeSpacingShimAttributes(token);
        var alignableAttributes = makeAlignableAttributes(token);
        var combinedClassNames = (0, classnames_1.default)(alignableAttributes === null || alignableAttributes === void 0 ? void 0 : alignableAttributes.className, resizeableAttributes === null || resizeableAttributes === void 0 ? void 0 : resizeableAttributes.className, spacingShimAttributes === null || spacingShimAttributes === void 0 ? void 0 : spacingShimAttributes.className, {
            "project-block__block-element": token.type === "block" &&
                !(0, CommonWidgetRegistry_1.hasTrait)({ widgetType: token.subType, traitName: "skipContainerAnimation" }),
        });
        var combinedStyles = __assign(__assign({}, resizeableAttributes === null || resizeableAttributes === void 0 ? void 0 : resizeableAttributes.style), styleableAttributes === null || styleableAttributes === void 0 ? void 0 : styleableAttributes.style);
        var attributes = __assign(__assign(__assign(__assign({}, resizeableAttributes), styleableAttributes), alignableAttributes), { className: combinedClassNames, style: combinedStyles });
        return registryRenderer({
            token: token,
            attributes: attributes,
            renderTokens: function (tokens, overrideOptions) { var _a, _b; return (_b = (_a = options.renderTokens) === null || _a === void 0 ? void 0 : _a.call(options, tokens, __assign(__assign({}, options), overrideOptions))) !== null && _b !== void 0 ? _b : ""; },
            innerHtml: innerHtml,
            index: index,
            isPrintMode: (_b = options.isPrintMode) !== null && _b !== void 0 ? _b : false,
            publicPageLink: options.secretLink,
            disableImgix: (_c = options.disableImgix) !== null && _c !== void 0 ? _c : false,
            tokens: tokens,
            sideBySideConfig: options.sideBySide,
            printOrientation: options.printOrientation,
        });
    }
    var renderer = TokenRenderers_1.tokenToCreateHtml.get(token.subType);
    if (!renderer) {
        throw new Error("Got an unknown block token subType: ".concat(token.subType));
    }
    return renderer(token, __assign(__assign({}, options), { index: index, innerHtml: innerHtml, tokens: tokens, renderTokens: tokenRenderer }));
};
var renderInlineToken = function (token) {
    var renderer = TokenRenderers_1.tokenToCreateHtml.get(token.subType);
    if (!renderer) {
        throw new Error("Got an unknown inline token subType: ".concat(token.subType));
    }
    return renderer(token, {
        renderTokens: tokenRenderer,
    });
};
exports.default = tokenRenderer;
